/* ============================================================
   SK Store – Scroll Reveal + Global JS
   Add to: assets/sk-store.js
   Load via: <script src="{{ 'sk-store.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll Reveal ─────────────────────────────────────── */

  let observer = null;

  function getObserver() {
    if (observer) return observer;

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('sk-revealed');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
    }
    return observer;
  }

  function initReveal(scope) {
    const root = scope || document;
    const revealEls = root.querySelectorAll('.sk-reveal:not(.sk-revealed)');

    if (!revealEls.length) return;

    const obs = getObserver();
    if (obs) {
      revealEls.forEach((el) => obs.observe(el));
    } else {
      // Fallback: just show all
      revealEls.forEach((el) => el.classList.add('sk-revealed'));
    }
  }

  // Initial run on page load
  initReveal(document);

  // Re-run whenever Shopify theme editor re-renders a section
  // (this fires on every settings change, e.g. picking manual products)
  document.addEventListener('shopify:section:load', (event) => {
    initReveal(event.target);
  });

  // Safety net: also catch block/section select events in the editor
  document.addEventListener('shopify:section:select', (event) => {
    initReveal(event.target);
  });

  /* ── Drag-to-scroll on all tracks ─────────────────────── */
  function initDragScroll(scope) {
    const root = scope || document;
    root.querySelectorAll('.sk-collections__track, .sk-products__track').forEach((track) => {
      if (track.dataset.skDragInit) return; // avoid double-binding on re-render
      track.dataset.skDragInit = '1';

      let isDown = false;
      let startX;
      let scrollLeft;

      track.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - track.offsetLeft;
        scrollLeft = track.scrollLeft;
      });

      track.addEventListener('mouseleave', () => { isDown = false; });
      track.addEventListener('mouseup', () => { isDown = false; });

      track.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - track.offsetLeft;
        const walk = (x - startX) * 1.5;
        track.scrollLeft = scrollLeft - walk;
      });
    });
  }

  initDragScroll(document);

  document.addEventListener('shopify:section:load', (event) => {
    initDragScroll(event.target);
  });

  /* ── Judge.me rating badges ───────────────────────────────
     Judge.me's own script only auto-scans badges present at
     page load. When the theme editor re-renders a section
     (e.g. picking manual products), newly injected badges
     need to be told to (re)initialize. ────────────────────── */
  document.addEventListener('shopify:section:load', () => {
    if (window.jdgm && typeof window.jdgm.batchRating === 'object') {
      try {
        window.jdgm.batchRating.loadBadges();
      } catch (e) {
        // Judge.me not ready yet, ignore
      }
    }
  });

  /* ── Open Dawn-style cart drawer after adding a product ──
     Fetches a fresh render of the "cart-drawer" section and
     swaps it into the existing <cart-drawer> element, then
     calls its open() method (standard Dawn cart-drawer.js API).
     Falls back to just refreshing the cart icon if the theme
     doesn't use this pattern. ─────────────────────────────── */
  function openCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return; // theme doesn't use a drawer, nothing to open

    fetch(`${window.location.origin}/?section_id=cart-drawer`)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');

        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.classList.remove('is-empty');
        }

        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          // Fallback: some Dawn versions just toggle this attribute
          cartDrawer.classList.add('active');
        }
      })
      .catch((err) => {
        console.error('Could not open cart drawer:', err);
      });
  }

  /* ── Add to Cart (AJAX) ────────────────────────────────── */
  // Called from onclick="skAddToCart(this, '{{ product.variants.first.id }}')"
  window.skAddToCart = function (btn, variantId) {
    if (!variantId) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    })
      .then((res) => {
        if (!res.ok) {
          return res.json().then((err) => {
            throw new Error(err.description || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(() => {
        btn.textContent = 'Added ✓';

        // Update cart count bubble if theme has one (common Dawn-based id/class)
        fetch('/cart.js')
          .then((res) => res.json())
          .then((cart) => {
            document
              .querySelectorAll('[data-sk-cart-count], .cart-count-bubble, #cart-icon-bubble')
              .forEach((el) => {
                el.textContent = cart.item_count;
              });
          })
          .catch(() => {});

        // Open the theme's cart drawer (Dawn-style <cart-drawer> element)
        openCartDrawer();

        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      })
      .catch((err) => {
        console.error('skAddToCart error:', err);
        btn.textContent = 'Error';
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1500);
      });
  };

})();

